import React, { useState } from 'react';
interface FAQItem {
  question: string;
  answer: string;
}
const faqs: FAQItem[] = [{
  question: '1 — ¿Cómo recibo el MegaPack después de comprar?',
  answer: 'Inmediatamente después de confirmar el pago recibís un email con el link de descarga. Acceso en menos de 5 minutos, sin importar el horario. Todo en PDF, directo a tu dispositivo.'
}, {
  question: '2 — ¿Sirve para parroquia o también para colegio?',
  answer: 'Para los dos. El contenido está pensado para la realidad argentina tanto de catequesis parroquial como de clase de religión en colegio. Podés adaptar cada tomo a tu contexto sin problema.'
}, {
  question: '3 — ¿Los 6 bonos están en las dos ofertas?',
  answer: 'Sí. Los 6 bonos están incluidos en ambas opciones sin costo adicional. La diferencia entre las dos ofertas es la inclusión de Adaptaciones para el Aula Real en el combo.'
}, {
  question: '4 — ¿Sirve si soy catequista nueva o con poca experiencia?',
  answer: 'Es ideal para vos. Cada tomo tiene objetivos claros, contenidos desarrollados y recursos listos. No necesitás experiencia previa para usarlo: el material te guía paso a paso.'
}, {
  question: '5 — ¿Qué diferencia tiene con materiales gratuitos de internet?',
  answer: 'Los materiales gratuitos son genéricos, desconectados por nivel y sin progresión pedagógica. Este MegaPack está pensado para la realidad argentina, ordenado por año y nivel de madurez de fe, con criterio doctrinal y pedagógico en cada tomo.'
}, {
  question: '6 — ¿Por qué elegir el combo con Adaptaciones para el Aula Real?',
  answer: 'Porque en Argentina el aula ideal no existe. Si alguna vez tuviste un grupo difícil, una semana corta, un contexto vulnerable o alumnos con niveles muy distintos (y seguro los tuviste), ese bono convierte el MegaPack en algo aplicable en cualquier realidad, no solo en la ideal.'
}, {
  question: '7 — ¿Tiene garantía real?',
  answer: 'Sí. 7 días, sin preguntas, devolución del 100%. Escribís a soporteprofepack@gmail.com y listo. Sin formularios, sin esperas, sin condiciones.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-[#0a0a0a] py-16 px-4" data-id="element-116">
      <div className="max-w-3xl mx-auto" data-id="element-117">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-10" data-id="element-118">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-3 mb-10" data-id="element-119">
          {faqs.map((faq, i) => <div key={i} className={`rounded-xl border transition-colors ${openIndex === i ? 'border-[#FFD700] bg-[#0d0a00]' : 'border-[#FFD700]/20 bg-black'}`} data-id="element-120">
              <button className="w-full text-left px-5 py-4 flex items-center justify-between gap-3" onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} data-id="element-121">
                <span className="text-white font-bold text-sm sm:text-base" data-id="element-122">
                  ❓ {faq.question}
                </span>
                <span className={`text-[#FFD700] text-xl flex-shrink-0 transition-transform ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-123">
                  +
                </span>
              </button>
              {openIndex === i && <div className="px-5 pb-5" data-id="element-124">
                  <div className="h-px bg-[#FFD700]/20 mb-4" data-id="element-125" />
                  {faq.answer.split('\n\n').map((para, j) => <p key={j} className="text-gray-200 text-sm leading-relaxed mb-3 last:mb-0" data-id="element-126">
                      {para}
                    </p>)}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}